import React from 'react';
import { ArrowRightIcon, MoveHorizontalIcon } from 'lucide-react';
import { FadeIn } from '../components/ui/FadeIn';
import { AppStoreButtons } from '../components/AppStoreButtons';
import { SiteFooter } from '../components/ui/SiteFooter';
import { appTourSteps } from '../data/appTour';
export function AppLaunchPage() {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-410" data-mp="2cws7acm9er7">
      {/* Navigation */}
      <nav className="sticky top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5" data-id="element-411" data-mp="35uy9ea3z41u1">
        <a href="/" aria-label="Fem Entity home" data-id="element-412" data-mp="3asq8bo31co7q">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-8 md:h-10" data-id="element-413" data-mp="3fl1br0wzis51" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-414" data-mp="2n3xf3zdssugt">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-415" data-mp="3potk8cmuslsc">
            Home
          </a>
          <a href="/practitioners" className="hover:text-purple-700 transition-colors" data-id="element-416" data-mp="3kpi51824xocv">
            Practitioners
          </a>
          <a href="/get-the-app" className="text-purple-700 font-semibold" data-id="element-417" data-mp="3fx76a8j4s8lw">
            Get the App
          </a>
        </div>
      </nav>

      <main data-id="element-418" data-mp="36z4y990zcfp4">
        {/* Launch hero */}
        <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-14 md:pb-20" data-id="element-419" data-mp="36zwrid73u1c8">
          <div className="max-w-4xl" data-id="element-420" data-mp="31xxpp7r0jche">
            <FadeIn data-id="element-421" data-mp="2x0fqi92ssbml">
              <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-6" data-id="element-422" data-mp="2wzw7sq5bpj7i">
                Now available on iOS and Android
              </p>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-charcoal leading-[1.05] tracking-tight" data-id="element-423" data-mp="v92k1fl6lvof">
                Your whole wellness team,{' '}
                <span className="italic text-purple-800" data-id="element-424" data-mp="r88wwofkckwl">in your pocket</span>
              </h1>
              <p className="mt-7 max-w-2xl text-lg md:text-xl text-charcoal/70 font-light leading-relaxed" data-id="element-425" data-mp="2kon3xjzinjt9">
                Get matched with verified practitioners, book care that fits
                your life, and track how you're really doing — all in the Fem
                Entity app.
              </p>
            </FadeIn>

            <FadeIn delay={150} data-id="element-426" data-mp="2foqzjjmwpqd6">
              <AppStoreButtons className="mt-10" data-id="element-427" data-mp="33gftf4fdmmw8" />
              <p className="mt-5 text-sm text-charcoal/50" data-id="element-428" data-mp="33el6xlogimq1">
                Free to download. Available across Canada, excluding Quebec.
              </p>
            </FadeIn>
          </div>
        </section>

        {/* Product storyboard — the real app screens */}
        <section aria-labelledby="storyboard-heading" className="bg-purple-50 border-y border-purple-100 py-16 md:py-20" data-id="element-429" data-mp="2zdrjetexf9xo">
          <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-430" data-mp="1nzxkhp88qj56">
            <FadeIn className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10" data-id="element-431" data-mp="1o1id39azvs0e">
              <div data-id="element-432" data-mp="1fh3o8zk6yb7a">
                <h2 id="storyboard-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-433" data-mp="1fkrk45d3z9p6">
                  A look inside the app
                </h2>
                <p className="mt-3 max-w-xl text-base text-charcoal/70 font-light leading-relaxed" data-id="element-434" data-mp="1khhzsrl043a2">
                  Every screen, from your first match to managing a full
                  practice.
                </p>
              </div>
              <p className="flex items-center gap-2 text-sm text-purple-800/80" data-id="element-435" data-mp="rux81q0m5p5z">
                <MoveHorizontalIcon aria-hidden="true" className="w-4 h-4" data-id="element-436" data-mp="16j0e0zenp0us" />
                Scroll sideways to explore
              </p>
            </FadeIn>
          </div>

          <div className="overflow-x-auto pb-4" data-id="element-437" data-mp="e1e7vzjsqsgp">
            <div className="px-6 md:px-12 min-w-max" data-id="element-438" data-mp="e0380ath24uv">
              <img src="https://cdn.magicpatterns.com/uploads/oYyQZqxXJFpQfReqPFmg9X/image.png" alt="Eight screens from the Fem Entity app: choosing to join as a practitioner or find care, the practitioner directory with a matching quiz, a verified practitioner profile, a daily mood check-in with journal prompts, booking a visit with a matched practitioner, a home screen of upcoming appointments, a practitioner's daily schedule, and a practitioner's account with balance, appointments, and booking requests." className="h-[430px] md:h-[560px] w-auto max-w-none rounded-2xl" data-id="element-439" data-mp="93mibc6mjifo" />
            </div>
          </div>
        </section>

        {/* The journey, in order */}
        <section aria-labelledby="journey-heading" className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28" data-id="element-440" data-mp="50myvr70jlte">
          <FadeIn data-id="element-441" data-mp="26rhxsrwio14c">
            <h2 id="journey-heading" className="font-serif text-3xl md:text-5xl text-charcoal leading-tight max-w-2xl" data-id="element-442" data-mp="26s00a69rvbkp">
              How it works, step by step
            </h2>
          </FadeIn>

          <ol className="mt-14 max-w-3xl border-l border-purple-200" data-id="element-443" data-mp="23b58yux428lv">
            {appTourSteps.map((step, index) => <li key={step.title} className="relative pl-8 md:pl-12 pb-12 last:pb-0" data-id="element-444" data-mp="1ygrc0o2svtf3" data-mpi={index}>
                <span aria-hidden="true" className="absolute -left-[13px] top-1 flex h-6 w-6 items-center justify-center rounded-full bg-purple-700 text-[11px] font-semibold text-white" data-id="element-445" data-mp="1tk0v5yj68tsm">
                  {index + 1}
                </span>
                <h3 className="font-serif text-xl md:text-2xl text-charcoal leading-snug" data-id="element-446" data-mp="2ha4z6709uvk5">
                  {step.title}
                </h3>
                <p className="mt-3 text-base text-charcoal/70 leading-[1.8]" data-id="element-447" data-mp="288xc6l37hh5d">
                  {step.description}
                </p>
              </li>)}
          </ol>
        </section>

        {/* Practitioner path */}
        <section className="bg-purple-100/70 border-y border-purple-200" data-id="element-448" data-mp="wsgwqrrnj0ii">
          <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-6" data-id="element-449" data-mp="ya5rrhxhxbck">
            <div className="max-w-2xl" data-id="element-450" data-mp="1398ngbrl657v">
              <h2 className="font-serif text-2xl md:text-3xl text-charcoal leading-snug" data-id="element-451" data-mp="pa985upyr2od">
                Are you a practitioner?
              </h2>
              <p className="mt-3 text-base text-charcoal/70 leading-relaxed" data-id="element-452" data-mp="t9ztvk0musm1">
                Apply to join our vetted network and manage your schedule,
                services, and payments from the same app.
              </p>
            </div>
            <a href="/practitioners" className="inline-flex items-center gap-2 rounded-full border border-charcoal/25 px-7 py-4 text-base font-semibold text-charcoal transition-colors duration-200 ease-out hover:border-purple-700 hover:text-purple-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-purple-100" data-id="element-453" data-mp="5m07ewactod9">
              Apply to the network
              <ArrowRightIcon aria-hidden="true" className="w-4 h-4" data-id="element-454" data-mp="3e63htd2p74mx" />
            </a>
          </div>
        </section>

        {/* Final download */}
        <section className="bg-charcoal py-20 md:py-28 text-center" data-id="element-455" data-mp="3n4xlfneg4v9z">
          <div className="max-w-3xl mx-auto px-6" data-id="element-456" data-mp="3j33p1rbaadfm">
            <FadeIn data-id="element-457" data-mp="3j2ar9fuayy9m">
              <h2 className="font-serif text-3xl md:text-5xl text-ivory leading-tight" data-id="element-458" data-mp="3j56nmzqi5evy">
                Start where you are
              </h2>
              <p className="mt-6 text-lg text-ivory/70 font-light leading-relaxed" data-id="element-459" data-mp="3s4a92ad566dm">
                Download the app and take the matching quiz — your first
                practitioner match takes about two minutes.
              </p>
            </FadeIn>
            <AppStoreButtons tone="dark" className="mt-10 justify-center items-center" data-id="element-460" data-mp="5qacludthfl6" />
          </div>
        </section>
      </main>

      <SiteFooter currentPath="/get-the-app" data-id="element-461" data-mp="eq6sp7m5564m" />
    </div>;
}